<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M197.665 94.4843C194.615 93.7126 191.517 95.5593 190.745 98.609C189.974 101.659 191.82 104.757 194.87 105.528L218.745 111.569C221.795 112.341 224.892 110.494 225.664 107.445C226.436 104.395 224.589 101.297 221.539 100.526L197.665 94.4843Z"
      class="fill-brand-100"
    />
    <path
      d="M208.883 28.16V165.754C208.883 167.891 207.149 169.632 205.005 169.632H114.573C112.435 169.632 110.694 167.898 110.694 165.754L110.694 28.16L208.883 28.16Z"
      class="fill-brand-300"
    />
    <path
      d="M124.32 52.8768H194.63C197.798 52.8768 200.634 50.848 201.747 47.7888L208.883 28.16H110.701L117.12 47.5584C118.17 50.7328 121.062 52.8704 124.32 52.8704V52.8768Z"
      class="fill-accent-500"
    />
    <path
      d="M159.552 71.5904C163.861 71.5904 167.354 68.0975 167.354 63.7888C167.354 59.4801 163.861 55.9872 159.552 55.9872C155.243 55.9872 151.75 59.4801 151.75 63.7888C151.75 68.0975 155.243 71.5904 159.552 71.5904Z"
      class="fill-accent-500"
    />
    <path
      d="M250.15 109.376H234.643C231.373 104.57 226.33 101.286 220.301 100.422C219.008 100.237 217.587 101.171 217.306 101.139C215.04 100.902 215.795 104.538 217.018 108.032H169.549C166.342 108.032 163.744 110.63 163.744 113.837C163.744 115.52 164.467 117.03 165.613 118.093C163.098 118.733 161.235 120.998 161.235 123.712C161.235 126.451 163.136 128.742 165.69 129.35C164.499 130.413 163.744 131.955 163.744 133.677C163.744 136.883 166.342 139.482 169.549 139.482H174.874C174.771 139.904 174.707 140.339 174.707 140.787C174.707 143.808 177.152 146.253 180.173 146.253H213.248C213.37 146.253 213.498 146.24 213.619 146.234C220.41 146.189 225.389 144.442 229.043 142.144C229.683 141.741 230.298 141.267 230.886 140.749H250.15V109.37V109.376ZM218.611 139.488L218.566 139.546C218.566 139.546 218.554 139.507 218.554 139.488H218.611Z"
      class="fill-brand-100"
    />
    <path
      d="M250.886 110.362V139.77C250.886 141.587 249.414 143.059 247.597 143.059H237.184V107.072H247.597C249.414 107.072 250.886 108.544 250.886 110.362Z"
      class="fill-brand-500"
    />
    <path
      d="M33.8323 158.97C30.7826 159.742 28.9359 162.839 29.7076 165.889C30.4793 168.939 33.5771 170.785 36.6268 170.014L60.5015 163.973C63.5512 163.201 65.3979 160.103 64.6262 157.053C63.8545 154.004 60.7567 152.157 57.707 152.929L33.8323 158.97Z"
      class="fill-brand-100"
    />
    <path
      d="M144.666 86.624V224.218C144.666 226.355 142.931 228.096 140.787 228.096H50.3552C48.2176 228.096 46.4768 226.362 46.4768 224.218L46.4768 86.624H144.666Z"
      class="fill-brand-500"
    />
    <path
      d="M94.1312 182.17C94.1312 179.456 92.2688 177.184 89.7536 176.55C90.8992 175.488 91.6224 173.978 91.6224 172.294C91.6224 169.088 89.024 166.49 85.8176 166.49H38.3488C39.5712 162.995 40.3264 159.36 38.0608 159.597C37.7792 159.629 36.3648 158.688 35.0656 158.88C29.0368 159.744 23.9872 163.027 20.7232 167.834H5.216V199.213H24.48C25.0688 199.731 25.6832 200.205 26.3232 200.608C29.984 202.906 34.9568 204.653 41.7472 204.698C41.8688 204.704 41.9904 204.717 42.1184 204.717H75.1936C78.2144 204.717 80.6592 202.266 80.6592 199.251C80.6592 198.797 80.6016 198.362 80.4928 197.946H85.8176C89.024 197.946 91.6224 195.347 91.6224 192.141C91.6224 190.419 90.8672 188.877 89.6768 187.814C92.2304 187.206 94.1312 184.915 94.1312 182.176V182.17ZM36.7936 197.997L36.7488 197.939H36.8064C36.8064 197.939 36.7936 197.978 36.7936 197.997Z"
      class="fill-brand-100"
    />
    <path
      d="M131.046 111.334H60.736C57.568 111.334 54.7328 109.306 53.6192 106.246L46.4832 86.624H144.666L138.246 106.022C137.197 109.197 134.304 111.334 131.046 111.334Z"
      class="fill-brand-100"
    />
    <path
      d="M18.1824 165.53L18.1824 201.517H7.76957C5.95197 201.517 4.47997 200.045 4.47997 198.227L4.47997 168.819C4.47997 167.002 5.95197 165.53 7.76957 165.53H18.1824Z"
      class="fill-secondary-500"
    />
    <path
      d="M95.8144 130.688C100.123 130.688 103.616 127.195 103.616 122.886C103.616 118.578 100.123 115.085 95.8144 115.085C91.5057 115.085 88.0128 118.578 88.0128 122.886C88.0128 127.195 91.5057 130.688 95.8144 130.688Z"
      class="fill-brand-100"
    />
  </svg>
</template>

<script>
  export default {
    name: 'ChangeAgreement'
  }
</script>
